import history from "../../config/history";
import { logout } from "./actions";
import { AuthenticationData, AuthenticationRole } from "./types";

class AuthenticationClass {

    authentication: AuthenticationData | null = null;
    authDataKey = "fvManagementAuthData";

    saveAuthentication() {
        const serializedAuthentication = JSON.stringify(this.authentication);
        localStorage.setItem(this.authDataKey, serializedAuthentication);
    }

    loadAuthentication() {
        const unserializedAuthentication = localStorage.getItem(this.authDataKey);
        if (unserializedAuthentication) {
            const authentication: AuthenticationData = JSON.parse(unserializedAuthentication);
            this.authentication = authentication;
            return
        }
        this.authentication = null;
    }

    clearAuthentication() {
        this.authentication = null;
        localStorage.removeItem(this.authDataKey);
    }

    isAdminAuthenticated() {
        if (this.authentication && this.authentication.authority) {
            if (this.authentication.authority === AuthenticationRole.ROLE_ADMIN) {
                return true
            }
        }
        return false
    }

    isAdjudicatorAuthenticated() {
        if (this.authentication && this.authentication.authority) {
            if (this.authentication.authority === AuthenticationRole.ROLE_ADMIN || this.authentication.authority === AuthenticationRole.ROLE_ADJUDICATOR) {
                return true
            }
        }
        return false
    }

    isOnlyAdjudicatorAuthenticated() {
        if (this.authentication && this.authentication.authority) {
            if (this.authentication.authority === AuthenticationRole.ROLE_ADJUDICATOR) {
                return true
            }
        }
        return false
    }

    async logout() {
        await logout();
        this.clearAuthentication();
        history.push("/login");
    }
}

const Authentication = new AuthenticationClass();
export default Authentication;